import React from 'react';

import { func_validation, func_cookieSetting, func_datetime } from 'functions';

export const columns = {
    // Columns Array
    getColumns,

    // Columns
    getColumns_advancePayId,
    getColumns_comId,
    getColumns_accountCode,
    getColumns_GLAccountCode,
    getColumns_dealerCode,
    getColumns_salesPersonCode,

    getColumns_productCode,
    getColumns_productName,

    getColumns_unitPrice,
    getColumns_billFrequence,
    getColumns_quantity,
    getColumns_chargeMethod,
    getColumns_subscriptionMethod,
    getColumns_isBillInForeignCurrency,
    getColumns_currencyCode,
    getColumns_currencyRate,

    getColumns_startDateTime,
    getColumns_nextBillDateTime,
}

function getColumns() {
    return [
        getColumns_advancePayId(),
        getColumns_comId(),
        getColumns_accountCode(),
        getColumns_GLAccountCode(),
        getColumns_dealerCode(),
        getColumns_salesPersonCode(),

        getColumns_productCode(),
        getColumns_productName(),

        getColumns_unitPrice(),
        getColumns_billFrequence(),
        getColumns_quantity(),
        getColumns_chargeMethod(),
        getColumns_subscriptionMethod(),
        getColumns_isBillInForeignCurrency(),
        getColumns_currencyCode(),
        getColumns_currencyRate(),
        
        getColumns_startDateTime(),
        getColumns_nextBillDateTime(),
    ];
}

function getColumns_advancePayId() {
    let columnClassName = "table__column-advance-pay-id";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Commitment Pay ID",
        id: "advancePayId",
        accessor: "Id",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_accountCode() {
    let columnClassName = "table__column-account-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Account Code",
        id: "accountCode",
        accessor: "AccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_GLAccountCode() {
    let columnClassName = "table__column-gl-account-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "GL Account Code",
        id: "GLAccountCode",
        accessor: "GLAccountCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_comId() {
    let columnClassName = "table__column-com-id";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Com ID",
        id: "comId",
        accessor: "CompanyId",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_productCode() {
    let columnClassName = "table__column-product-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Product Code",
        id: "productCode",
        accessor: "ProductCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_productName() {
    let columnClassName = "table__column-product-name";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Product Name",
        id: "productName",
        accessor: "ProductName",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_dealerCode() {
    let columnClassName = "table__column-dealer-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Dealer Code",
        id: "dealerCode",
        accessor: "DealerCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_salesPersonCode() {
    let columnClassName = "table__column-sales-person-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Sales Person Code",
        id: "salesPersonCode",
        accessor: "SalesPersonCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_unitPrice() {
    let columnClassName = "table__column-unit-price";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Unit Price (RM)",
        id: "unitPrice",
        accessor: "UnitPrice",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_billFrequence() {
    let columnClassName = "table__column-bill-frequence justify-content-center";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Bill Frequence",
        id: "billFrequence",
        accessor: "BillFrequence",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_quantity() {
    let columnClassName = "table__column-quantity justify-content-center";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Quantity",
        id: "quantity",
        accessor: "Quantity",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_chargeMethod() {
    let columnClassName = "table__column-charge-method";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Charge Method",
        id: "chargeMethod",
        accessor: "ChargeMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_subscriptionMethod() {
    let columnClassName = "table__column-subscription-method";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Subscription Method",
        id: "subscriptionMethod",
        accessor: "SubscriptionMethod",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_isBillInForeignCurrency() {
    let columnClassName = "table__column-is-bill-in-foreign-currency";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Bill in Foreign Currency",
        id: "isBillInForeignCurrency",
        accessor: "IsBillInForeignCurrency",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isBooleanNotNullUndefined(value)? value + "": "-";

            return (
                <div  className={"noWrap-text-ellipsis"}>{func_validation.getUserFriendlyTrueFalseDisplay(value_formatted + "")}</div>
            );
        },
        width: 200
    }
}

function getColumns_currencyCode() {
    let columnClassName = "table__column-currency-code";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Currency Code",
        id: "currencyCode",
        accessor: "CurrencyCode",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_currencyRate() {
    let columnClassName = "table__column-currency-rate";

    return {
        headerCellClassName: columnClassName + " justify-content-start",
        Header: "Currency Rate",
        id: "currencyRate",
        accessor: "CurrencyRate",
        bodyCellClassName: columnClassName + " justify-content-end",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isNumberValid(value)? value: "-";
            if (value_formatted != "-")
                value_formatted = func_cookieSetting.getFormattedPrice(value_formatted, { currencyDisabled: true });

            return (
                <div className={"noWrap-text-ellipsis "}>{value_formatted}</div>
            );
        },
    }
}

function getColumns_startDateTime() {
    let columnClassName = "table__column-start-date-time";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Start Date Time",
        id: "startDateTime",
        accessor: "StartDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        },
    }
}


function getColumns_nextBillDateTime() {
    let columnClassName = "table__column-next-bill-date-time";

    return {
        headerCellClassName: columnClassName + " ",
        Header: "Next Bill Date Time",
        id: "nextBillDateTime",
        accessor: "NextBillDateTime",
        bodyCellClassName: columnClassName + " ",
        Cell: (props) => {
            let cell = func_validation.getObjectPropertyValue(props, "cell");
            let value = func_validation.getObjectPropertyValue(cell, "value");
            let value_formatted = func_validation.isStringTrimNotEmpty(value)? value: "-";
            if (func_validation.isStringTrimNotEmpty(value_formatted) && (value_formatted != "-")) 
                value_formatted = func_datetime.convertDateTimeToLocal(value_formatted, "DD/MM/YYYY");

            return (
                <div className={"noWrap-text-ellipsis"}>{value_formatted}</div>
            );
        }
    }
}